import { render, staticRenderFns } from "./CourseTemplates.vue?vue&type=template&id=010f0e1d&"
import script from "./CourseTemplates.vue?vue&type=script&lang=js&"
export * from "./CourseTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports